import * as React from "react";
import { Link } from "react-router-dom";
import { Button, Divider, Header, Message, Segment } from "semantic-ui-react";
import OrganizationsBase, {
  IOrganizationsBaseProps,
  IOrganizationsBaseState,
} from "../Organizations/OrganizationsBase";
import * as routes from "src/constants/routes";

export default class ListOrganizations extends OrganizationsBase<
  IOrganizationsBaseProps,
  IOrganizationsBaseState
> {
  constructor(props: IOrganizationsBaseProps) {
    super(props);
    this.state = { ...OrganizationsBase.INITIAL_STATE };
  }

  public render() {
    const { orgs, loading } = this.state;

    return (
      <React.Fragment>
        <Header content="Your Organizations" textAlign="left" as="h1" />
        {!loading && orgs && orgs.length > 0 && (
          <React.Fragment>
            {orgs.map((option: any) => (
              <Segment key={option.id} style={{ height: "65px" }}>
                <div
                  style={{ float: "left", marginRight: "5px" }}
                  className="org-label"
                >
                  {option.name.charAt(0).toUpperCase()}
                </div>
                <div className="org-name">{option.name}</div>
                <Button
                  floated="right"
                  primary={true}
                  positive={true}
                  onClick={() => this.handleOrgClicked(option.id)}
                  content="Open"
                />
              </Segment>
            ))}
          </React.Fragment>
        )}
        {!loading && orgs && orgs.length === 0 && (
          <Message info={true} compact={true}>
            <Message.Header>
              You are not part of any organization. 1
            </Message.Header>
            <p>
              If you know the organization, request the admin to send you an
              invitation email.
            </p>
          </Message>
        )}
        <Divider horizontal={true}>or</Divider>
        <Link to={routes.NEW_ORGANIZATION}>Create an organization</Link>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Organizations/ListOrganizations.tsx